import { TaishakuTaishoKmkType } from '@/repositories/keiei-joho/taishaku-taisho/data'

// 第一引数の配列で金額集約 ＆ 第二引数にその金額集約値を設定
export function aggregateAndSet (items: TaishakuTaishoKmkType[], type: string): number {
  const sum = items.filter(i => !i.isAggregate).reduce((acc, i) => acc + (i.kin || 0), 0)
  items.forEach(i => {
    if (i.kmkType === type) i.kin = sum
  })
  return sum
}
